import { Component, Inject, OnInit } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA, DateAdapter, MAT_DATE_FORMATS } from '@angular/material';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { startWith } from 'rxjs/internal/operators/startWith';
import { map } from 'rxjs/operators';
import { FirestoreService } from 'src/services/firestore/firestore.service';
import { AppDateAdapter } from 'src/shared/format-datepicker';
import Swal from 'sweetalert2';

@Component({
    selector: 'dialog-evaluacion-general',
    templateUrl: 'evaluacionGeneral.component.html',
    providers: [
        { provide: DateAdapter, useClass: AppDateAdapter },
    ]
})
export class EvaluacionGeneralComponent implements OnInit {

    filteredNivel: Observable<any[]>;
    /**
     * Opciones a mostrar en nivel
     */
    opcionesNivel = [
        {
            nombre: 'Kinder'
        },
        {
            nombre: 'Pre Kinder'
        },

        {
            nombre: 'Medio Mayor'
        },
        {
            nombre: 'Medio Menor'
        },
        {
            nombre: 'Sala Cuna Mayor'
        },
        {
            nombre: 'Sala Cuna Menor'
        },
    ];


    public newEvaluacForm = new FormGroup({
        // nivel: new FormControl([], Validators.required),
        nivel: new FormControl([], Validators.required),
        observacion: new FormControl('', Validators.required),
        fecha: new FormControl('', Validators.required),
    });
    constructor(
        public dialogRef: MatDialogRef<EvaluacionGeneralComponent>, private firestoreService: FirestoreService) { }

    ngOnInit() {
        this.filtroNivel();
    }

    onNoClick(): void {
        this.dialogRef.close();
    }


    /**
     * Segun lo que se ingrese en el input de nivel se actualizaran las opciones a mostrar
     */
    filtroNivel() {
        this.filteredNivel = this.newEvaluacForm.controls.nivel.valueChanges.pipe(
            startWith(''),
            map(value => typeof value === 'string' ? value : value.nombre),
            map(name => name ? this._filterNivel(name) : this.opcionesNivel.slice())
        );
    }

    private _filterNivel(name: string): any[] {
        const filterValue = name.toLowerCase();
        return this.opcionesNivel.filter(option => option.nombre.toLowerCase().indexOf(filterValue) === 0);
    }

    guardar() {
        this.firestoreService.createEvaluacObs({
            nivel: this.newEvaluacForm.controls.nivel.value,
            observacion: this.capitalize(this.newEvaluacForm.controls.observacion.value.toLowerCase()),
            fecha: this.newEvaluacForm.controls.fecha.value.getTime()
        });
        this.dialogRef.close();
        Swal.fire(
            'Creado!',
            'El registro se creo correctamente.',
            'success'
        );
    }

    capitalize(valor) {
        return valor.charAt(0).toUpperCase() + valor.slice(1);
    }

}
